"use client"

import { Badge } from "@chakra-ui/react/badge"
import { Box } from "@chakra-ui/react/box"
import { Flex } from "@chakra-ui/react/flex"
import { Link } from "@chakra-ui/react/link"
import { FC } from "react"

import colors from "simple-color-functions"

import ErrorMessage from "@/components/ErrorMessage"
import { Category } from "@/types/database"
import { ArrowUpRightIcon } from "@/components/icons"

interface CategoryBadgeListProps {
  categories: Category[]
}

const CategoryBadgeList: FC<CategoryBadgeListProps> = ({ categories }) => {
  // console.log('categories', categories);
  return (
    <>
      {categories && categories.length > 0 ? (
        <>
          <Flex
            alignItems="flex-start"
            columnGap={"0.5rem"}
            data-nc-id="CategoryBadgeList"
            flexDirection="row"
            justifyContent="flex-start"
            pointerEvents="all"
            rowGap="0.2rem"
            wrap={"wrap"}
          >
            {categories.map((item: Category) => {
              return (
                <div key={item.slug}>
                  {item !== undefined && (
                    <Link
                      backgroundSize="0 0"
                      className="block"
                      href={`/writing?categories=${item.slug}`}
                      textDecoration={"none"}
                    >
                      <Badge
                        _hover={{
                          "& .arrow": {
                            opacity: 1,
                            transform: "translateX(0)",
                            width: "12px",
                          },
                          bg: colors(String(item.color)).darken(0.3).hex(),
                          borderColor: colors(String(item.color))
                            .darken(0.3)
                            .hex(),
                          color: colors(String(item.icon_color))
                            .darken(3)
                            .hex(),
                        }}
                        bgColor={item.color}
                        border={"1px solid"}
                        borderColor={colors(String(item.color))
                          .darken(0.5)
                          .hex()}
                        borderRadius="12px"
                        color={item.icon_color}
                        fontSize="0.75rem"
                        lineHeight="1rem"
                        paddingBottom="0.20rem"
                        paddingLeft="0.625rem"
                        paddingRight="0.625rem"
                        paddingTop="0.20rem"
                        transition={
                          "color 0.3s ease, background-color 0.3s ease"
                        }
                      >
                        {item.title}
                        <Box
                          as={"span"}
                          className="arrow"
                          css={{
                            "& svg": {
                              height: "12px",
                              width: "12px",
                            },
                          }}
                          opacity={0}
                          rounded="full"
                          transform="translateX(100%)"
                          transition="transform 0.16s ease-in, width 0.16s ease-in, opacity 0.16s ease-in"
                          width="0px"
                          zIndex={12}
                        >
                          <ArrowUpRightIcon />
                        </Box>
                      </Badge>
                    </Link>
                  )}
                </div>
              )
            })}
          </Flex>
        </>
      ) : (
        <ErrorMessage
          message="Please try again."
          title="Unable to locate the work categories!"
        />
      )}
    </>
  )
}

export default CategoryBadgeList
